var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"text-center py-5 my-5"},[_c('b-spinner',{staticClass:"mt-2",attrs:{"variant":"primary","label":"Spinning"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }